@if (billAccount) {
  <div class="margin-bottom-40">
    <span class="weight-bold"><b>Paperless Billing</b></span>
    <!-- <p dsContent [contentPath]="'billing.paperlessBillingPreferencesExplanation'" ></p> -->
    <p>
      Lorem ipsum at purus, at vitae <a>Terms and Services</a> in turpis dapibus mi metus, vitae.
    </p>
    <form [formGroup]="paperlessBillingForm">
      @for (option of options; track option) {
        <div>
          <input
            type="radio"
            [value]="option.value"
            formControlName="paperlessOption"
            (click)="enablePaperBillingOptionForm(option.value)"
          />
          {{ option.display }}
        </div>
      }
    </form>
    <div class="margin-top-40">
      @if (!editPaperlessOptions) {
        <div class="margin-bottom-40">
          <form [formGroup]="emailForm">
            <div class="row">
              <div class="column twelve lg-six">
                <ds-form-control-container
                  [labelText]="'Email Address'"
                  [labelClass]="'no-float'"
                  [control]="emailForm.controls['emailAddress']"
                >
                  <input
                    id="emailAddress"
                    class="fill neutral-600-bg"
                    formControlName="emailAddress"
                  />
                </ds-form-control-container>
              </div>
            </div>
          </form>
          <a href="#">Change My Account email here</a>
        </div>
      }
      @if (editPaperlessOptions) {
        <div>
          <form [formGroup]="addressForm" (ngSubmit)="validateAddress(addressForm.value)">
            <div class="row">
              <div class="column twelve">
                <div class="row">
                  <div class="column twelve lg-six">
                    <ds-form-control-container
                      [labelText]="'Billing Address'"
                      [control]="addressForm.controls['billingAddress']"
                    >
                      <input id="billingAddress" class="fill" formControlName="billingAddress" />
                      <ds-form-control-message
                        [control]="addressForm.controls['billingAddress']"
                      ></ds-form-control-message>
                    </ds-form-control-container>
                  </div>
                </div>
                <div class="row">
                  <div class="column twelve lg-four">
                    <ds-form-control-container
                      [labelText]="'city'"
                      [control]="addressForm.controls['city']"
                    >
                      <input id="city" class="fill" formControlName="city" />
                      <ds-form-control-message
                        [control]="addressForm.controls['city']"
                      ></ds-form-control-message>
                    </ds-form-control-container>
                  </div>
                  <div class="column twelve lg-four">
                    <ds-form-control-container
                      [labelText]="'state'"
                      [control]="addressForm.controls['state']"
                    >
                      <select id="state" class="icon fill" formControlName="state">
                        @for (state of states; track state) {
                          <option [value]="state">{{ state }}</option>
                        }
                      </select>
                      <span class="icon-chevron-down"></span>
                      <ds-form-control-message
                        [control]="addressForm.controls['state']"
                      ></ds-form-control-message>
                    </ds-form-control-container>
                  </div>
                  <div class="column twelve lg-four">
                    <ds-form-control-container
                      [labelText]="'zipCode'"
                      [control]="addressForm.controls['zipCode']"
                    >
                      <input id="zipCode" class="fill" formControlName="zipCode" />
                      <ds-form-control-message
                        [control]="addressForm.controls['zipCode']"
                      ></ds-form-control-message>
                    </ds-form-control-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-space-around">
              <div>
                <button
                  ds-button
                  authCheck
                  [permissionName]="'editbillingpreferences'"
                  [checkAction]="'disable'"
                  type="submit"
                  [disabled]="!addressForm.valid"
                  dsContent
                  [contentPath]="'shared.saveBtn'"
                ></button>
              </div>
              <div><a dsContent [contentPath]="'shared.cancel'"></a></div>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
}
